module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceButtonRenderModule",
    "path": "front/piece-button-render.module"
  },
  "cms-module": {
    "name": "PieceButtonCmsModule",
    "path": "front/piece-button-cms.module"
  },
  "definition": {
    "type": "button",
    "name": "PieceButtonDefinition",
    "group": "Basic",
    "availablePlatforms": ["web", "apps"],
    "description": "Botón",
    "fields": [
      {
        "name": "text",
        "label": "Texto del botón",
        "type": "richText",
        "placeholder": "Escribe el texto",
        "validators": ["textOrImage"]
      },
      {
        "name": "textPadding",
        "label": "Padding al texto",
        "type": "linkedUnits",
        "jsonPath": "styles.padding"
      },
      {
        "label": "Enlace",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "link",
            "label": "Url de destino",
            "type": "link",
            "mandatory": true
          }
        ]
      },
      {
        "label": "Imagen",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "Image",
            "type": "linkedImages",
            "validators": ["textOrImage"]
          },
          {
            "name": "title",
            "label": "Título (title)",
            "placeholder": "Title (SEO)",
            "type": "plainText"
          },
          {
            "name": "alt",
            "label": "Texto alternativo (Alt)",
            "placeholder": "Texto alternativo (accesibilidad)",
            "type": "plainText"
          }
        ]
      },
      {
        "name": "buttonStyles",
        "label": "Estilos del botón",
        "type": "groupCollapsable",
        "fields": [
          {
            "name": "buttonStylesTabs",
            "type": "groupTabs",
            "flattenFields": true,
            "tabs": [
              {
                "label": "Normal",
                "fields": ["backgroundColor"]
              },
              {
                "label": "Hover",
                "fields": ["hoverBackgroundColor", "hoverColor"]
              },
              {
                "label": "Presionado",
                "fields": ["pressedBackgroundColor", "pressedColor"]
              }
            ],
            "fields": [
              {
                "name": "backgroundColor",
                "label": "Color de fondo",
                "type": "color",
                "jsonPath": "styles.backgroundColor"
              },
              {
                "name": "hoverBackgroundColor",
                "label": "Color de fondo",
                "type": "color",
                "jsonPath": "styles.hoverBackgroundColor",
                "isExcluded": true
              },
              {
                "name": "hoverColor",
                "label": "Color de texto",
                "type": "color",
                "jsonPath": "styles.hoverColor",
                "isExcluded": true
              },
              {
                "name": "pressedBackgroundColor",
                "label": "Color de fondo",
                "type": "color",
                "jsonPath": "styles.pressedBackgroundColor"
              },
              {
                "name": "pressedColor",
                "label": "Color de texto",
                "type": "color",
                "jsonPath": "styles.pressedColor"
              }
            ]
          },
          {
            "name": "imageToTextPosition",
            "type": "options",
            "label": "Posición de la imagen respecto al texto",
            "jsonPath": "styles.imageToTextPosition",
            "defaultValue": "up",
            "values": [
              {
                "label": "Encima",
                "value": "up"
              },
              {
                "label": "Debajo",
                "value": "down"
              },
              {
                "label": "Izquierda",
                "value": "left"
              },
              {
                "label": "Derecha",
                "value": "right"
              },
              {
                "label": "En el cursor al hacer hover",
                "value": "hover"
              }
            ]
          }
        ]
      },
      {
        "name": "textPositionVertical",
        "label": "Posición vertical",
        "type": "options",
        "section": "styles",
        "defaultValue": "middle",
        "values": [
          {
            "value": "up",
            "label": "Arriba"
          },
          {
            "value": "middle",
            "label": "Centro"
          },
          {
            "value": "down",
            "label": "Abajo"
          }
        ]
      },
      {
        "name": "border",
        "label": "Borde",
        "type": "groupCollapsable",
        "section": "styles",
        "isFolded": true,
        "flattenFields": true,
        "fields": [
          {
            "name": "borderStyle",
            "label": "Estilo del borde",
            "type": "options",
            "section": "styles",
            "defaultValue": "none",
            "values": [
              {
                "value": "none",
                "label": "Sin borde"
              },
              {
                "value": "solid",
                "label": "Línea"
              },
              {
                "value": "dotted",
                "label": "Puntuado"
              },
              {
                "value": "dashed",
                "label": "Rayado"
              },
              {
                "value": "double",
                "label": "Doble"
              },
            ]
          },
          {
            "name": "borderColors",
            "type": "groupTabs",
            "flattenFields": true,
            "tabs": [
              {
                "label": "Normal",
                "fields": ["borderColor"]
              },
              {
                "label": "Hover",
                "fields": ["hoverBorderColor"]
              },
              {
                "label": "Presionado",
                "fields": ["pressedBorderColor"]
              }
            ],
            "fields": [
              {
                "name": "borderColor",
                "label": "Color del borde",
                "type": "color"
              },
              {
                "name": "hoverBorderColor",
                "label": "Color del borde",
                "type": "color",
                "isExcluded": true
              },
              {
                "name": "pressedBorderColor",
                "label": "Color del borde",
                "type": "color"
              }
            ]
          },
          {
            "name": "borderWidth",
            "label": "Grosor",
            "type": "units",
            "defaultValue": "0px",
            "disableUnits": ['%', 'vw', 'vh']
          },
          {
            "name": "borderRadiusType",
            "label": "Tipo de radio de borde",
            "type": "options",
            "section": "styles",
            "flattenFields": true,
            "defaultValue": "custom",
            "values": [
              {
                "value": "straight",
                "label": "Recto"
              },
              {
                "value": "semi-round",
                "label": "Semiredondeado"
              },
              {
                "value": "round",
                "label": "Redondeado"
              },
              {
                "value": "custom",
                "label": "Personalizado",
                "shouldDisplayWhenSelected": "borderRadius",
              }
            ]
          },
        ]
      }
    ],
    "disableStyles": [
      "background",
      "border"
    ]
  }
};
